import * as React from "react";
import { ProjectTabProps } from "../Projects";
import { Row, Col, message, FormInstance, Form } from "antd";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { SwitcherItem } from "./SwitcherItem";
import { API_MODULEDATA_MODULE } from "General/APIEnums";
import { Loader } from "Components/General/Loader";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { observer } from "mobx-react";
import { projectSubmitStore } from "Pages/Admin/Stores/ProjectStore";
import { userInfoStore } from "Stores";
import dm from "@/assets/img/svg/oa-white.svg";
import ft from "@/assets/img/svg/fd-white.svg";
import sj from "@/assets/img/svg/ot-white.svg";
import cl from "@/assets/img/svg/qm-white.svg";

interface ModuleConfig {
  name: string;
  module: API_MODULEDATA_MODULE;
  icon: IconName | React.ReactNode;
  description: string;
  showStartWith: boolean;
}

enum ModulesGroupName {
  BASIC = "BASIC",
  PROJECT_MANAGEMENT = "PROJECT_MANAGEMENT",
  DOCS_PLANS = "DOCS_PLANS",
  CONSTRUCTIONS = "CONSTRUCTIONS",
  PRO4ALL = "PRO4ALL",
}

interface ModulesSelectionProps extends WithTranslation {
  value?: { [key in API_MODULEDATA_MODULE]: boolean };
  onChange?: (v: { [key in API_MODULEDATA_MODULE]: boolean }) => { [key in API_MODULEDATA_MODULE]: boolean };
  onChangeStartsWith: (module: API_ADMINPROJECT_STARTWITH) => void;
  startWithValue: API_ADMINPROJECT_STARTWITH;
}

export const ModulesSelection = withTranslation(I18N_NS.ADMIN)(
  class extends React.Component<ModulesSelectionProps> {
    private modulesConfig: {
      classicAndModern: { [key in ModulesGroupName]?: ModuleConfig[] };
      onlyClassic: { [key in ModulesGroupName]?: ModuleConfig[] };
      onlyModern?: { [key in ModulesGroupName]?: ModuleConfig[] };
    } = {
      classicAndModern: {
        BASIC: [
          {
            name: "Communication",
            module: API_MODULEDATA_MODULE.MAIL,
            icon: "envelope",
            description: "Project emails",
            showStartWith: true,
          },
          {
            name: "Workflows",
            module: API_MODULEDATA_MODULE.WORKFLOW,
            icon: "code-branch",
            description: "Must be configured separately",
            showStartWith: true,
          },
          {
            name: "Tasks",
            module: API_MODULEDATA_MODULE.TASKS,
            icon: "tasks",
            description: "Manage tasks",
            showStartWith: true,
          },
          {
            name: "Q&A",
            module: API_MODULEDATA_MODULE.QA,
            icon: "comments",
            description: "Questions and Answers",
            showStartWith: true,
          },
          {
            name: "Calls for tenders",
            module: API_MODULEDATA_MODULE.TENDER_MODERN,
            icon: "gavel",
            description: "Organize tenders",
            showStartWith: true,
          },
          {
            name: "Organisations",
            module: API_MODULEDATA_MODULE.ORGANIZATIONS,
            icon: "users-class",
            description: "",
            showStartWith: false,
          },
        ],
        DOCS_PLANS: [
          {
            name: "Folder view",
            module: API_MODULEDATA_MODULE.DOCUMENTS,
            icon: "folder-tree",
            description: "Formerly Documents",
            showStartWith: true,
          },
          {
            name: "Table view",
            module: API_MODULEDATA_MODULE.VIEW,
            icon: "table",
            description: "Formerly Views",
            showStartWith: true,
          },
        ],
      },
      onlyClassic: {
        BASIC: [
          {
            name: "Calendar",
            module: API_MODULEDATA_MODULE.CALENDAR,
            icon: "calendar",
            description: "",
            showStartWith: false,
          },
          {
            name: "Claim Cockpit",
            module: API_MODULEDATA_MODULE.CLAIM_COCKPIT,
            icon: "file-archive",
            description: "For demonstration",
            showStartWith: false,
          },
          {
            name: "Contract Management",
            module: API_MODULEDATA_MODULE.CONTRACTMANAGEMENT,
            icon: "handshake",
            description: "Reminder for files",
            showStartWith: false,
          },

          {
            name: "E-Akte",
            module: API_MODULEDATA_MODULE.EAKTE,
            icon: "file-word",
            description: "For demonstration",
            showStartWith: false,
          },
          {
            name: "Webcam",
            module: API_MODULEDATA_MODULE.WEBCAM,
            icon: "video",
            description: "Save pictures on a scheduled basis",
            showStartWith: false,
          },
          // {
          //   name: 'Calls for tenders',
          //   module: API_MODULEDATA_MODULE.TENDER,
          //   icon: 'gavel',
          //   description: 'Organise tenders'
          // }
        ],
      },
      onlyModern: {
        BASIC: [
          {
            name: "BIM (BCF)",
            module: API_MODULEDATA_MODULE.BIM_ISSUES,
            icon: "cube",
            description: "",
            showStartWith: false,
          },
          {
            name: "Objects and data (value tables)",
            module: API_MODULEDATA_MODULE.VALUE_TABLE,
            icon: "shapes",
            description: "",
            showStartWith: true,
          },
          {
            name: "Investigations",
            module: API_MODULEDATA_MODULE.INVESTIGATIONS,
            icon: "puzzle-piece",
            description: "Needs full text search in Documents",
            showStartWith: true,
          },
          {
            name: "KPI Dashboard",
            module: API_MODULEDATA_MODULE.KPI_DASHBOARD,
            icon: "analytics",
            description: "",
            showStartWith: true,
          },
        ],
        PROJECT_MANAGEMENT: [
          {
            name: "List of open points",
            module: API_MODULEDATA_MODULE.LOP,
            icon: "tasks-alt",
            description: "",
            showStartWith: false,
          },
          {
            name: "Protocol management",
            module: API_MODULEDATA_MODULE.PROTOCOLLMANAGEMENT,
            icon: "calendar-day",
            description: "MoM",
            showStartWith: false,
          },
          {
            name: "Plan Delivery List",
            module: API_MODULEDATA_MODULE.PLAN_DELIVERY_LIST,
            icon: "business-time",
            description: "",
            showStartWith: false,
          },
        ],
        CONSTRUCTIONS: [
          {
            name: "Defect management",
            module: API_MODULEDATA_MODULE.ONLINEBAUABNAHME,
            icon: <img src={dm} alt="Defect management" style={{ margin: `0 5px`, width: 20 }} />,
            description: "",
            showStartWith: false,
          },
          {
            name: "Site journal",
            module: API_MODULEDATA_MODULE.CONSTRUCTIONLOG,
            icon: <img src={sj} alt="Defect management" style={{ margin: `0 5px`, width: 20 }} />,
            description: "",
            showStartWith: false,
          },
          {
            name: "Fotos",
            module: API_MODULEDATA_MODULE.OX_FOTOS,
            icon: <img src={ft} alt="Defect management" style={{ margin: `0 5px`, width: 20 }} />,
            description: "",
            showStartWith: false,
          },
          {
            name: "Checklists",
            module: API_MODULEDATA_MODULE.OX_CHECKLISTS,
            icon: <img src={cl} alt="Defect management" style={{ margin: `0 5px`, width: 20 }} />,
            description: "",
            showStartWith: false,
          },
        ],
        PRO4ALL: [
          {
            name: "STA Account Linking",
            module: API_MODULEDATA_MODULE.STA_INTEGRATION,
            icon: "link",
            description: "",
            showStartWith: false,
          },
        ],
      },
    };

    handleChange = (projectModule: API_MODULEDATA_MODULE) => {
      const { onChange, value = {} as { [key in API_MODULEDATA_MODULE]: boolean } } = this.props;
      if (typeof onChange !== "function") {
        console.warn("onChange handler is not set up!");
        return;
      }
      let newValue = {} as { [key in API_MODULEDATA_MODULE]: boolean };
      newValue = this.handleDependencies(projectModule, value);
      onChange(newValue);
    };

    handleDependencies = (projectModule: API_MODULEDATA_MODULE, value: { [key in API_MODULEDATA_MODULE]: boolean }) => {
      const { t } = this.props;
      if (projectModule === "PROTOCOLLMANAGEMENT") {
        if (value.LOP === false && value[projectModule] === false) {
          message.info(
            t("The LOPs Module was activated because it is needed for the Meeting Minutes Management Module")
          );
          return { ...value, [projectModule]: true, LOP: true };
        } else {
          return { ...value, [projectModule]: !value[projectModule] };
        }
      } else if (projectModule === "LOP") {
        if (value[projectModule] === false) {
          return { ...value, [projectModule]: true };
        } else if (value[projectModule] === true && value.PROTOCOLLMANAGEMENT) {
          message.warning(
            t("Cannot deactivate the LOPs Module, it is needed for the Meeting Minutes Management Module")
          );
          return { ...value, [projectModule]: true };
        } else {
          return { ...value, [projectModule]: false };
        }
      } else {
        if (value[projectModule] === false) {
          return { ...value, [projectModule]: true };
        } else {
          return { ...value, [projectModule]: false };
        }
      }
    };

    handleStartsWithChange = (projectModule: API_MODULEDATA_MODULE) => {
      const { onChangeStartsWith } = this.props;
      onChangeStartsWith(projectModule);
    };

    renderSwitcher = (items: ModuleConfig[]) =>
      items.map((item, idx) => {
        const { t } = this.props;
        return (
          <SwitcherItem
            key={idx}
            onChange={() => this.handleChange(item.module)}
            checked={this.props.value[item.module]}
            onStartsWithChange={() => this.handleStartsWithChange(item.module)}
            defaultChecked={this.props.value && this.props.value[item.module]}
            name={t(item.name)}
            description={t(item.description)}
            icon={item.icon}
            showStartWith={item.showStartWith}
            pickedAsStartWith={item.module === this.props.startWithValue}
          />
        );
      });

    render() {
      const { t } = this.props;
      return (
        <Row gutter={20}>
          <Col md={12} className="mb-lg">
            <h2>{t("Classic and Modern")}</h2>
            <div className="mt-1 mb-lg">
              <h4>{t("Module group: Documents and plans")}</h4>
              {this.renderSwitcher(this.modulesConfig.classicAndModern.DOCS_PLANS)}
            </div>
            {this.renderSwitcher(this.modulesConfig.classicAndModern.BASIC)}
          </Col>
          <Col md={12} className="mb-lg">
            <h2>{t("Purely Classic")}</h2>
            {this.renderSwitcher(this.modulesConfig.onlyClassic.BASIC)}
          </Col>
          <Col md={12} className="mb-lg">
            <h2>{t("Purely Modern")}</h2>
            {this.renderSwitcher(this.modulesConfig.onlyModern.BASIC)}
            {this.modulesConfig.onlyModern.PROJECT_MANAGEMENT && (
              <div className="mt-1 mb-sm">
                <h4>{t("Module group: Project management")}</h4>
                {this.renderSwitcher(this.modulesConfig.onlyModern.PROJECT_MANAGEMENT)}
              </div>
            )}
            {userInfoStore.isSysAdmin && (
              <>
                <div className="mt-1 mb-sm">
                  <h4>{t("Module group: Construction site")}</h4>
                  {this.renderSwitcher(this.modulesConfig.onlyModern.CONSTRUCTIONS)}
                </div>
                <div className="mt-1 mb-sm">
                  <h4>{t("Module group: Pro4All groupintegration")}</h4>
                  {this.renderSwitcher(this.modulesConfig.onlyModern.PRO4ALL)}
                </div>
              </>
            )}
          </Col>
        </Row>
      );
    }
  }
);

interface ModulesTabProps extends ProjectTabProps {
  modulesActive: { [key in API_MODULEDATA_MODULE]: boolean };
  startWith: API_ADMINPROJECT_STARTWITH;
  hasModules: boolean;
  formRef: React.RefObject<FormInstance>;
}

export const ModulesTab = observer(
  class ModulesTab extends React.Component<ModulesTabProps> {
    handleChangeStartsWith = (module: API_ADMINPROJECT_STARTWITH) =>
      projectSubmitStore.updateData({ startWith: module });

    render() {
      if (!this.props.hasModules) {
        return <Loader />;
      }

      const { modulesActive } = this.props;
      return (
        <div>
          <Form.Item name="modules" initialValue={modulesActive}>
            <ModulesSelection
              onChangeStartsWith={this.handleChangeStartsWith}
              startWithValue={projectSubmitStore.data.startWith}
            />
          </Form.Item>
        </div>
      );
    }
  }
);
